<div class="reservation-confirmation-container">
  <!-- Content -->
  <div class="reservation-confirmation-content">
    <!-- Schedule Info -->
    <p class="reservation-confirmation-info">
      <span class="info-text"
        >{{ 'RESERVATION_CONFIRMATION.SCHEDULE_INTRO' | translate }}
        <br aria-hidden="true" />
      </span>
      <span class="info-bold"> </span>
      <span class="info-bold schedule-time">{{ formattedSchedule }}</span>
      <span class="info-bold"> </span>
      <span class="info-text">
        <br aria-hidden="true" />
        {{ 'RESERVATION_CONFIRMATION.CONFIRMATION_NOTE' | translate }}
      </span>
    </p>

    <!-- Currency Cards -->
    <div class="reservation-confirmation-currencies">
      <!-- Pay Currency Card -->
      <div class="currency-card">
        <div class="currency-card-header">
          <h5>{{ 'RESERVATION_CONFIRMATION.PAY_TITLE' | translate }}</h5>
        </div>
        <div class="currency-card-body">
          <div class="currency-flag-section">
            <div class="currency-flag-wrapper">
              <img
                *ngIf="cotizacion?.from?.currency?.logoUrl"
                [src]="cotizacion.from.currency.logoUrl"
                [alt]="cotizacion.from.currency.code | currencyName : cotizacion.from.currency.name"
                class="currency-flag"
              />
              <mat-icon *ngIf="!cotizacion?.from?.currency?.logoUrl"
                class="currency-flag-icon" svgIcon="currency_exchange"></mat-icon>
            </div>
            <p class="currency-code">{{ cotizacion?.from?.currency?.code }}</p>
          </div>
          <div class="currency-details">
            <p class="currency-name">
              {{
                cotizacion?.from?.currency?.code
                  | currencyName
                    : (cotizacion?.from?.currency?.fullName ||
                        cotizacion?.from?.currency?.name)
              }}
            </p>
            <p class="currency-amount">
              <ng-container
                *ngIf="
                  isCentenarioCurrencyCode(
                    cotizacion?.from?.currency?.code ||
                      cotizacion?.from?.currency?.name
                  );
                  else confirmPayMoney
                "
                >{{ fromAmount | centenarioUnits }}</ng-container
              >
              <ng-template #confirmPayMoney
                ><span>$ {{ fromAmount | number : "1.2-2" }}</span></ng-template
              >
            </p>
          </div>
        </div>
      </div>

      <!-- Receive Currency Card -->
      <div class="currency-card">
        <div class="currency-card-header">
          <h5>{{ 'RESERVATION_CONFIRMATION.RECEIVE_TITLE' | translate }}</h5>
        </div>
        <div class="currency-card-body">
          <div class="currency-flag-section">
            <div class="currency-flag-wrapper">
              <img
                *ngIf="cotizacion?.to?.currency?.logoUrl"
                [src]="cotizacion.to.currency.logoUrl"
                [alt]="cotizacion.to.currency.code | currencyName : cotizacion.to.currency.name"
                class="currency-flag"
              />
              <mat-icon *ngIf="!cotizacion?.to?.currency?.logoUrl"
                class="currency-flag-icon" svgIcon="currency_exchange"></mat-icon>
            </div>
            <p class="currency-code">{{ cotizacion?.to?.currency?.code }}</p>
          </div>
          <div class="currency-details">
            <p class="currency-name">
              {{
                cotizacion?.to?.currency?.code
                  | currencyName
                    : (cotizacion?.to?.currency?.fullName ||
                        cotizacion?.to?.currency?.name)
              }}
            </p>
            <p class="currency-amount">
              <ng-container
                *ngIf="
                  isCentenarioCurrencyCode(
                    cotizacion?.to?.currency?.code ||
                      cotizacion?.to?.currency?.name
                  );
                  else confirmReceiveMoney
                "
                >{{ toAmount | centenarioUnits }}</ng-container
              >
              <ng-template #confirmReceiveMoney
                ><span>$ {{ toAmount | number : "1.2-2" }}</span></ng-template
              >
            </p>
          </div>
        </div>
      </div>
    </div>

    <app-foreign-pair-notice
      [currencyFromCode]="cotizacion?.from?.currency?.code"
      [currencyToCode]="cotizacion?.to?.currency?.code"
    ></app-foreign-pair-notice>

    <!-- Branch Section -->
    <div class="reservation-confirmation-branch">
      <div class="branch-section-header">
        <h5>{{ 'BRANCH_SELECTOR.TITLE' | translate }}</h5>
      </div>
      <div class="branch-card">
        <div class="branch-card-content">
          <div class="branch-info-section">
            <div class="branch-icon-container">
              <img
                class="branch-icon"
                src="./assets/img/circle-icon.svg"
                alt="Branch icon"
              />
            </div>
            <div class="branch-text-info">
              <p class="branch-name">{{ sucursal.name }}</p>
              <p class="branch-city">{{ sucursal.address.city }}</p>
            </div>
            <div class="branch-address-row">
              <mat-icon
                color="accent"
                class="branch-location-icon"
                svgIcon="fmd_good"
              ></mat-icon>
              <p class="branch-address">{{ fullAddress }}</p>
            </div>
          </div>
          <div class="branch-schedule-badge" *ngIf="formattedSchedule">
            <mat-icon class="schedule-icon" svgIcon="access_time"></mat-icon>
            <span class="schedule-text">{{ getFormattedSchedule() }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Required Documentation Section -->
    <app-required-documentation
      [amountUsd]="documentationAmountUsd"
    ></app-required-documentation>

    <!-- Points Section -->
    <div class="reservation-confirmation-points">
      <div class="points-display">
        <div class="points-icon-container">
          <img
            class="points-icon"
            src="./assets/img/circle-icon.svg"
            alt="Points icon"
          />
        </div>
        <p class="points-amount">{{ estimatedPoints }} pts</p>
      </div>
      <div class="points-info">
        <p class="points-text">
          {{ 'RESERVATION_CONFIRMATION.POINTS_CAPTION' | translate }}
        </p>
        <button
          class="points-help-button"
          mat-fab
          [matTooltip]="'RESERVATION_CONFIRMATION.POINTS_HELP' | translate"
        >
          <mat-icon svgIcon="help_outline"></mat-icon>
        </button>
      </div>
    </div>
  </div>
</div>
